import DataTable from "react-data-table-component";
import { FaDownload, FaEdit, FaTrash } from "react-icons/fa";
import React from "react";
import "../../../assets/scss/tableData.css";

const GenericTable = ({
  columnList = [],
  data,
  tableData,
  expandableRows = false,
  ExpandedComponent,
  handleEdit,
  handleDelete,
  handlePageChange,
  currentPage,
  totalCount,
  handleDownload,
  renderExpandableRow,
  totalPages,
  paginationPerPage
}) => {
  const updatedColumnList = Array.isArray(columnList) ? [...columnList] : [];

  const dynamicColumns = updatedColumnList.map(({ label, field, cell }, index) => {        
    let columnWidth = "auto";   
    if ( label === "Chapter") {
      columnWidth = "80px"; 
    } else if (label === "Name") {
      columnWidth = "250px";
    } else if (label === "Related industry") {
      columnWidth = "140px";
    } else if (label === "Description") {
      columnWidth = "550px"; 
    } else if (label === 'no'){
      columnWidth = '40px'
    } else if(label === 'SubCategory 3'){
      columnWidth = '100px'
    } else if(label === 'SubCategory 2'){
      columnWidth = '100px'
    }else if(label === 'SubCategory 1'){
      columnWidth = '100px'
    }else if(label === 'Main ATC Category'){
      columnWidth = '100px'
    }else if(label === 'Part'){
      columnWidth = '100px'
    }else if(label === 'CAS No'){
      columnWidth = '100px'
    }else if(label === 'Product Group'){
      columnWidth = '350px'
    }else if(label === 'Product UniqueName'){
      columnWidth = '350px'
    }else if(label === 'Product Name'){
      columnWidth = '350px'
    }else if(label === 'Curated Product Name'){
      columnWidth = '350px'
    }else if(label === 'Date'){
      columnWidth = '140px'
    }else if(label === 'User'){
      columnWidth = '120px'
    }else if(label === 'Unique Product Name'){
      columnWidth = '350px'
    }else if(label === 'Input Records'){
      columnWidth = '120px'
    }
    
    
    return {
      name: <span className="font-weight-bold fs-13">{label}</span>,
      selector: (row) => row[field],
      sortable: true,
      cell,
      width: columnWidth,
      wrap: true,
    };
  });
  
  const columns = dynamicColumns.filter(
    (column) => column.name.props.children !== "Password"
  );
  const hasNameLabel = updatedColumnList?.[2]?.label === "Email";
  const hasCasNoLabel = updatedColumnList?.[2]?.label === "CAS No";  

  const editButtonColumn = {
    name: <span className="font-weight-bold fs-13">Edit</span>,
    sortable: false,
    cell: (row) => (
      <button
        onClick={() => handleEdit(row)}
        style={{
          backgroundColor: "white",
          color: "#333333",
          padding: 5,
          fontSize: 15,
        }}
      >
        <FaEdit style={{ fontSize: 16, color: "blue", cursor: "pointer" }} />
      </button>
    ),
  };

  const deleteButtonColumn = {
    name: <span className="font-weight-bold fs-13">Delete</span>,
    sortable: false,
    cell: (row) => (
      <button
        onClick={() => handleDelete(row)}
        style={{
          backgroundColor: "white",
          color: "red",
          padding: 5,
          fontSize: 15,
        }}
      >
        <FaTrash style={{ fontSize: 16, color: "red", cursor: "pointer" }} />
      </button>
    ),
  };

  if (hasNameLabel) columns.push(editButtonColumn, deleteButtonColumn);
  if(hasCasNoLabel)columns.push(editButtonColumn);

  const DefaultExpandedComponent = ({ data }) => {
    if (!renderExpandableRow) return null;
    const expandableData = renderExpandableRow(data);
    if (!expandableData || expandableData.length === 0) return null;

    return (
      <div style={{ padding: "0px 10px 10px 50px", backgroundColor: "#f9f9f9" }}>
        <DataTable
          columns={columns}
          data={expandableData}
          noHeader
          noTableHead
          customStyles={{
            table: {
              style: {
                backgroundColor: "transparent",
                margin: "0",
                border: "none",
                // tableLayout: "auto",
              },
            },
            head: {
              style: {
                display: "none",
              },
            },
            rows: {
              style: {
                minHeight: "40px",
                backgroundColor: "transparent",
                borderBottom: "1px solid #eee",
              },
            },
            cells: {
              style: {
                padding: "5px",
                // whiteSpace: "normal"
              },
            },
          }}
        />
      </div>
    );
  };

  const customStyles = {
    headCells: {
      style: {
        paddingLeft: "0",
        paddingRight: "0",
      },
    },
    cells: {
      style: {
        paddingLeft: "",
        paddingRight: "",
      },
    },
  };

  return (
    <DataTable
      columns={columns}
      data={data || tableData}
      expandableRows={expandableRows || !!renderExpandableRow}
      expandableRowsComponent={ExpandedComponent || DefaultExpandedComponent}
      pagination
      paginationServer={true}
      paginationTotalRows={totalCount}
      paginationPerPage={paginationPerPage || 25}
      onChangePage={handlePageChange}
      paginationDefaultPage={currentPage}
      paginationComponentOptions={{ noRowsPerPage: true }}
      customStyles={customStyles}
    />
  );
};

export default GenericTable;